import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
    selector: 'app-svg-icon',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'svg-icon.component.html',
    styleUrls: ['svg-icon.component.scss'],
})
export class SvgIconComponent {
    private _iconPath: string = ''
    private paths: RegExp[] = [
        /^\/?assets\/img\/new-designs\/icons\/[a-zA-Z0-9\-_]+\.svg$/,
        /^\/?assets\/img\/new-designs\/[a-zA-Z0-9\-_]+\.svg$/,
        /^\/?assets\/img\/[a-zA-Z0-9\-_]+\.svg$/,
    ]

    @Input()
    set iconPath(value: string) {
        const isValidPath = this.paths.some((regex) => regex.test(value))

        if (!isValidPath) {
            console.warn('Invalid icon path format')
            return
        }
        this._iconPath = value
    }

    get iconPath(): string {
        return this._iconPath
    }
}
